var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.516 0.236671C4.069 -0.00538755 3.54253 0.0641251 3.17376 0.41542L3.16507 0.42411C2.80374 0.775405 2.71186 1.29304 2.93163 1.74736L6.96952 10.0382C7.1595 10.4329 7.55062 10.6824 7.98893 10.6886C8.42723 10.6948 8.82457 10.4577 9.02696 10.068L13.1915 1.68281C13.4249 1.23097 13.3455 0.705891 12.9879 0.344665C12.6303 -0.0165601 12.105 -0.102211 11.6518 0.127434L9.03937 2.157C8.46697 2.60139 7.66734 2.6076 7.08748 2.1719L4.516 0.236671Z",
    fill: "#FEBC11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72961 7.16406L3.29425 7.18889C3.10551 7.18889 2.93665 7.30061 2.86215 7.47315L0.875488 12.0971L5.90547 9.58216L4.72961 7.16406Z",
    fill: "#21438E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37585 10.5593L6.26783 10.3979L5.31299 10.8858L8.53014 14.0959L14.6255 10.9367L13.1379 7.47339C13.0634 7.30084 12.8933 7.18912 12.7059 7.18912L11.4257 6.92969L9.59548 10.3955C9.27141 11.0087 8.63692 11.3923 7.94407 11.3947C7.31455 11.3972 6.72476 11.0832 6.37585 10.5593Z",
    fill: "#21438E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.295529 13.433L0.038505 14.0301C-0.094353 14.3392 0.132871 14.6843 0.470603 14.6843H7.37798C7.42143 14.652 7.42143 14.6545 7.65363 14.5341L4.43151 11.3203L0.294287 13.433H0.295529Z",
    fill: "#21438E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9615 14.0165L14.9979 11.7734L9.40674 14.6719H15.5294C15.8659 14.6719 16.0943 14.3268 15.9615 14.0178V14.0165Z",
    fill: "#21438E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2493 4.8799C9.2493 4.23069 8.72035 3.70312 8.06972 3.70312C7.41909 3.70312 6.89014 4.23069 6.89014 4.8799C6.89014 5.52911 7.41909 6.05668 8.06972 6.05668C8.72035 6.05668 9.2493 5.52911 9.2493 4.8799Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.aef23987a4050ddafbe69a0018968f77.svg";
export { ForwardRef as ReactComponent };